export default function () {
	return {
		welcome_banner: []
	}
}
